export const THEME_KEY = 'app-theme';

export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';

export type Theme = 'light' | 'dark';
export const THEMES: Theme[] = [
    THEME_LIGHT,
    THEME_DARK,
];
